import {InjectionToken} from '@angular/core';
import {AccountModePort} from '../ports/account-mode.port';

export const ACCOUNT_MODE_SERVICE = new InjectionToken<AccountModePort>('ACCOUNT_MODE_SERVICE');
